module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c3/sec04_pc_23d276c29f4f05f017ce918560aa8333.jpg";